var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-sk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4ea2",
    d: "M0 0h512v341.333H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v170.667H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.204 395.52c-45.893-22.106-111.539-65.982-111.539-152.775s4.15-126.265 4.15-126.265h214.781s4.15 39.472 4.15 126.265-65.645 130.67-111.542 152.775z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.204 384c-42.103-20.28-102.329-60.534-102.329-140.16 0-79.628 3.807-115.84 3.807-115.84h197.047s3.808 36.212 3.808 115.84c0 79.626-60.226 119.88-102.332 140.16z",
    fill: "#ee1c25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.21 222.962c11.4.185 33.643.631 53.448-5.996 0 0-.523 7.087-.523 15.343 0 8.258.523 15.345.523 15.345-18.166-6.08-40.601-6.206-53.448-6.043v43.98H194.2v-43.98c-12.846-.163-35.28-.037-53.448 6.042 0 0 .523-7.086.523-15.344 0-8.256-.523-15.344-.523-15.344 19.806 6.628 42.048 6.181 53.448 5.997v-27.62c-10.39-.093-25.364.403-42.293 6.069 0 0 .523-7.087.523-15.345 0-8.256-.523-15.344-.523-15.344 16.904 5.656 31.86 6.16 42.247 6.07-.534-17.491-5.63-39.536-5.63-39.536s10.487.818 14.68.818c4.196 0 14.68-.818 14.68-.818s-5.095 22.046-5.63 39.535c10.39.09 25.344-.414 42.248-6.07 0 0-.523 7.087-.523 15.344s.523 15.344.523 15.344c-16.93-5.665-31.903-6.161-42.294-6.069v27.62z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.2 280.827c-21.203 0-32.56 29.413-32.56 29.413s-6.3-13.946-23.6-13.946c-11.704 0-20.33 10.411-25.813 20.053 21.294 33.881 55.268 54.79 81.973 67.653 26.708-12.864 60.705-33.767 82-67.653-5.483-9.642-14.11-20.053-25.814-20.053-17.3 0-23.626 13.946-23.626 13.946s-11.356-29.413-32.56-29.413z",
    fill: "#0b4ea2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.747d53f4060149b56df87cfb62f24044.svg";
export { ForwardRef as ReactComponent };